import { createContext } from 'react';
import * as api from '../api';

export type ConfigurationContextProps = Pick<
  api.OrganizationAssistantConfiguration.ConfigurationWithSession,
  | 'id'
  | 'organizationId'
  | 'careTeamName'
  | 'greetingMessage'
  | 'promptQuestions'
  | 'inputTextHeroPlaceholder'
  | 'inputTextMainPagePlaceholder'
  | 'inputHelperText'
  | 'toneAttributes'
  | 'iconConversationUrl'
  | 'sessionId'
  | 'previsitUseNotionalSchedulingTimeSlots'
  | 'ssoAuthEnabled'
  | 'ssoEnabled'
  | 'ssoAuthButtonLabel'
  | 'ssoAuthButtonIcon'
  | 'transparentHeroBackgroundEnabled'
  | 'heroCommonQuestionsHeader'
  | 'eyebrowContent'
> & {
  authenticated: boolean;
  isEmbedded: boolean;
  authenticationEnabled: boolean;
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  reconciliationStatus?: api.Previsit.ReconciliationStatus;
  setReconciliationStatus: React.Dispatch<
    React.SetStateAction<api.Previsit.ReconciliationStatus | undefined>
  >;
  onVisibleInViewport: () => void;
};

export const ConfigurationContext = createContext<
  Partial<ConfigurationContextProps> | undefined
>(undefined);
